<template>
  <PageWrapper :title="title" ref="pageEl">
    <div class="header">
      <sc-button variant="primary" :route="createButton.route">{{
        createButton.title
      }}</sc-button>
    </div>
    <insurance-list :data="insuranceList"></insurance-list>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import InsuranceList from "../components/InsuranceList";
import { baanRueJaiClient } from "@/dependencies";
export default {
  components: {
    PageWrapper,
    ScButton,
    InsuranceList
  },
  data() {
    const title = "รายการประกัน";
    const createButton = {
      title: "เพิ่มประกัน",
      route: { name: "InsuranceCreatePage" }
    };
    const insurances = [];
    const total = 0;

    return {
      title,
      createButton,
      insurances,
      total
    };
  },
  computed: {
    insuranceList() {
      return this.insurances.map(insurance => {
        const id = insurance.id;
        const title = insurance.title;
        const subtitle = insurance.subtitle;
        const icon = insurance.icon_url;
        const route = { name: "InsuranceDetailPage", params: { id } };

        return {
          id,
          title,
          subtitle,
          icon,
          route
        };
      });
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupInsuranceList();
    },
    async setupInsuranceList() {
      const insurances = await this.fetchInsuranceList();

      this.insurances = insurances;
    },
    async fetchInsuranceList() {
      const response = await baanRueJaiClient.admin.insurances.list();

      return response.data.result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  padding: 30px;
  border-bottom: $border;
}
</style>



// WEBPACK FOOTER //
// src/features/insurance/pages/InsuranceListPage.vue